import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./Certificate.scss";
import certificateImage from "src/assets/images/hassantuk-certificate-bg.png";
import {
  convertDateIFNotMin,
  getCurrentDateTimeFormatted,
  getTextValueById,
} from "src/utils/helpers";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { ReactComponent as ArticleShortcut } from "../../assets/icons/article_shortcut.svg";
import { Button } from "primereact/button";
import { getCategoryOptions } from "src/redux/slices/lookupSlice";
import { useTranslation } from "react-i18next";
const Certificate = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation(["common"]);

  const citiesOptions = useSelector((state: any) => state.lookup.citiesOptions);
  const emirateOptions = useSelector(
    (state: any) => state.lookup.emiratesOptions
  );
  const language = useSelector((state: any) => state.lookup.language);
  const {
    registrationDate,
    companyName,
    tradeLicenseNumber,
    tradeLicenseExpiryDate,
    civilDefenseLicenseNo,
    civilDefenceLicenseExpiryDate,
    categoryOfLicense,
    officeAddress,
    emirate,
    city,
    contactPersonName,
    designation,
    mobile,
    emailID,
    numberOfPropertiesRegistered,
    companybmcID,
    validityDate,
  } = useSelector((state: any) => state.invoices.paymentClearanceData);
  const categoryOptions = useSelector(
    (state: any) => state.lookup.categoryOptions
  );
  function getEmirate(id: any) {
    return getTextValueById(id, emirateOptions, "emirateId");
  }

  function getCity(id: any) {
    return getTextValueById(id, citiesOptions, "cityId");
  }
  function getCategory() {
    return getTextValueById(categoryOfLicense, categoryOptions, "id");
  }

  const generatePDF = () => {
    const input = document.getElementById("certificate");
    if (input) {
      html2canvas(input, { scale: 2 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: "a4",
        });
        const pdfWidth = 297; // A4 width in mm
        const pdfHeight = 210; // A4 height in mm
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("certificate.pdf");
      });
    }
  };
  const customReverse = () => {
    return language === "ar" ? "reverse" : "";
  };

  useEffect(() => {
    dispatch(getCategoryOptions() as any);
  }, []);

  return (
    <div>
      <div className="d-flex justify-content-end">
        <Button
          className="edit-btn primary-btn mx-0 my-3 "
          icon={<ArticleShortcut className="m-0" />}
          onClick={generatePDF}
        >
          {t("downloadPDF")}
        </Button>
      </div>
      <div id="certificate" className="certificate-container" dir="ltr">
        <img
          src={certificateImage}
          alt="Certificate"
          className="certificate-bg"
        />
        <div className="certificate-overlay">
          <div className="certificate-content ">
            <div className={`certificate-row ${customReverse()}`}>
              <div className={`certificate-item ${customReverse()}`}>
                <span className="certificate-font english">
                  Certificate Issue Date:
                </span>
                <strong>{getCurrentDateTimeFormatted("DD/MM/YYYY")}</strong>
                <span className="certificate-font arabic">
                  تاريخ إصدار الشهادة:
                </span>
              </div>
              <div className={`certificate-item ${customReverse()}`}>
                <span className="certificate-font english">
                  Certificate Validity Date:
                </span>
                <strong>{convertDateIFNotMin(validityDate)}</strong>
                <span className="certificate-font arabic">
                  تاريخ انتهاء صلاحية الشهادة:
                </span>
              </div>
            </div>
            <div className={`certificate-row ${customReverse()}`}>
              <div className={`certificate-item ${customReverse()}`}>
                <span className="certificate-font english">
                  Registration Date:
                </span>
                <strong>{convertDateIFNotMin(registrationDate)}</strong>
                <span className="certificate-font arabic">تاريخ التسجيل:</span>
              </div>
              <div className={`certificate-item ${customReverse()}`}>
                <span className="certificate-font english">Address:</span>
                <strong> {officeAddress} </strong>
                <span className="certificate-font arabic">العنوان:</span>
              </div>
            </div>
            <div className={`certificate-row ${customReverse()}`}>
              <div className={`certificate-item ${customReverse()}`}>
                <span className="certificate-font english">BMC Name:</span>
                <strong> {companyName} </strong>
                <span className="certificate-font arabic">اسم الشركة:</span>
              </div>
              <div className={`certificate-item ${customReverse()}`}>
                <span className="certificate-font english">City:</span>
                <strong> {getCity(city)} </strong>
                <span className="certificate-font arabic">المدينة:</span>
              </div>
            </div>
            <div className={`certificate-row ${customReverse()}`}>
              <div className={`certificate-item ${customReverse()}`}>
                <span className="certificate-font english">BMC ID:</span>
                <strong> {companybmcID}</strong>
                <span className="certificate-font arabic">رقم الشركة:</span>
              </div>
              <div className={`certificate-item ${customReverse()}`}>
                <span className="certificate-font english">Emirate:</span>
                <strong> {getEmirate(emirate)}</strong>
                <span className="certificate-font arabic">الإمارة:</span>
              </div>
            </div>
            <div className={`certificate-row ${customReverse()}`}>
              <div className={`certificate-item ${customReverse()}`}>
                <span className="certificate-font english">
                  Trade License No:
                </span>
                <strong> {tradeLicenseNumber}</strong>
                <span className="certificate-font arabic">
                  رقم الرخصة التجارية:
                </span>
              </div>
              <div className={`certificate-item ${customReverse()}`}>
                <span className="certificate-font english">
                  Contact Person:
                </span>
                <strong> {contactPersonName}</strong>
                <span className="certificate-font arabic">
                  اسم الشخص المسؤول:
                </span>
              </div>
            </div>
            <div className={`certificate-row ${customReverse()}`}>
              <div className={`certificate-item ${customReverse()}`}>
                <span className="certificate-font english">
                  Trade License Expiry Date:
                </span>
                <strong>{convertDateIFNotMin(tradeLicenseExpiryDate)}</strong>
                <span className="certificate-font arabic">
                  تاريخ انتهاء الرخصة التجارية:
                </span>
              </div>
              <div className={`certificate-item ${customReverse()}`}>
                <span className="certificate-font english">Mobile:</span>
                <strong> {mobile} </strong>
                <span className="certificate-font arabic">الهاتف المحمول:</span>
              </div>
            </div>
            <div className={`certificate-row ${customReverse()}`}>
              <div className={`certificate-item ${customReverse()}`}>
                <span className="certificate-font english">
                  Civil Defense License Number:
                </span>
                <strong> {civilDefenseLicenseNo}</strong>
                <span className="certificate-font arabic">
                  رقم رخصة الدفاع المدنى:
                </span>
              </div>
              <div className={`certificate-item ${customReverse()}`}>
                <span className="certificate-font english">Email ID:</span>
                <strong> {emailID}</strong>
                <span className="certificate-font arabic">
                  البريد الإليكترونى:
                </span>
              </div>
            </div>
            <div className={`certificate-row ${customReverse()}`}>
              <div className={`certificate-item ${customReverse()}`}>
                <span className="certificate-font english">
                  Civil Defense License Expiry Date:
                </span>
                <strong>
                  {convertDateIFNotMin(civilDefenceLicenseExpiryDate)}
                </strong>
                <span className="certificate-font arabic">
                  تاريخ انتهاء رخصة الدفاع المدني:
                </span>
              </div>
              <div className={`certificate-item ${customReverse()}`}>
                <span className="certificate-font english">Designation:</span>
                <strong> {designation}</strong>
                <span className="certificate-font arabic">الوظيفه:</span>
              </div>
            </div>
            <div className={`certificate-row ${customReverse()}`}>
              <div className={`certificate-item ${customReverse()}`}>
                <span className="certificate-font english">
                  Category of License:
                </span>
                <strong> {getCategory()}</strong>
                <span className="certificate-font arabic">فئة الرخصة:</span>
              </div>
              <div className={`certificate-item ${customReverse()}`}>
                <span className="certificate-font english">
                  Number of Properties:
                </span>
                <strong> {numberOfPropertiesRegistered}</strong>
                <span className="certificate-font arabic">عدد المنشآت:</span>
              </div>
            </div>
            <div className=" certificate-footer ">
              <p className="certificate-font english  d-flex certificate-footer-lang ">
                <span>
                  This Certificate confirms that, as of the issue date,
                </span>
                <strong className="certificate-company-name">
                  {companyName}
                </strong>
                <span>
                  is registered in the BMC and their status is active.
                </span>
              </p>
              <p className="certificate-font arabic d-flex certificate-footer-lang">
                <span>تؤكد هذه الشهادة أنه، اعتباراً من تاريخ الإصدار،</span>
                <strong className="certificate-company-name">
                  {companyName}
                </strong>
                <span>مسجلة في نظام متابعة شركات الصيانة و حسابها فعال.</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Certificate;
